function CancelPage(params) {
  return (
    <div className="py-10 py-lg-20 p-9 mt-19 h-lg-1000px">
      <div className="container">
        <div className="text-center mb-12">
          <h1 className=""> Cancel Page </h1>
        </div>
      </div>
    </div>
  );
}

export default CancelPage;
